import * as styles from "./styles.css";
import { PlaceholderImage } from "../../atoms/placeholder-image";
import * as M from "@discovery/prelude/lib/data/maybe";
import { BackButton, BackButtonVariant, } from "../../../components/atoms/back-button";
import Description from "./descrption";
import { goBackToPreviousPage } from "../../../utils/common";
const PlayerView = React.lazy(() => import("../../../component-creators/player"));
const LiveTvMastHead = ({ read, liveTvVideoDataM, genre, descriptionM, imaAdsConfig, }) => {
    const streamIdM = M.chain((x) => x.streamIdM, liveTvVideoDataM);
    const videoNameM = M.chain((x) => M.of(x.name), liveTvVideoDataM);
    const packagesM = M.chain((x) => x.packagesM, liveTvVideoDataM);
    return (React.createElement(React.Fragment, null,
        React.createElement(BackButton, { variant: BackButtonVariant.WithBackground, customBackNavigation: true, goBackTo: goBackToPreviousPage }),
        React.createElement("div", { className: styles.mobileBannerWrapper },
            React.createElement("div", { className: styles.placeholderstyleM },
                React.createElement(PlaceholderImage, null)),
            React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
                React.createElement(PlayerView, { streamIDM: streamIdM, read: read, imaAdsConfig: imaAdsConfig, packagesM: packagesM }))),
        React.createElement(Description, { videoName: M.fromMaybe(videoNameM, ""), genre: genre, descriptionM: descriptionM })));
};
export default LiveTvMastHead;

